module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-buffer bottom-buffer"
  }, [(_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), (_vm.help_text_url) ? [_c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })] : _vm._e(), _vm._v(" "), _vm._l((_vm.repeatableGroups), function(group, groupIdx) {
    return _c('div', {
      key: ("repeatable_group_" + (_vm.component.name) + "_" + groupIdx),
      staticClass: "repeatable-group",
      attrs: {
        "id": ("repeatable_group_" + (_vm.component.name) + "_" + groupIdx)
      }
    }, [_c('div', {
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('label', {
      staticClass: "inline",
      attrs: {
        "id": (_vm.id + "_" + groupIdx)
      }
    }, [_vm._v(_vm._s(_vm.label) + " " + _vm._s(_vm.add_1(groupIdx)))]), _vm._v(" "), _c('a', {
      staticClass: "collapse-link-top pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleGroupVisibility(group)
        }
      }
    }, [(_vm.isExpanded(group)) ? _c('span', {
      staticClass: "glyphicon glyphicon-chevron-down"
    }) : _c('span', {
      staticClass: "glyphicon glyphicon-chevron-up"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      class: {
        'collapse': true, 'in': !_vm.isExpanded(group)
      },
      staticStyle: {
        "margin-top": "10px"
      }
    }, _vm._l((_vm.components[group].children), function(subcomponent, index) {
      return _c('div', {
        key: ("repeatable_group_subcomponent_" + (subcomponent.name) + "_" + index)
      }, [_c('renderer-block', {
        key: ("repeatable_group_subcomponent_contents_" + (subcomponent.name) + "_" + index),
        attrs: {
          "component": subcomponent,
          "json_data": _vm.value
        }
      }), _vm._v(" "), _c('div', [(_vm.num_groups() > 1 && index == _vm.component.children.length - 1 && !_vm.readonly) ? _c('button', {
        staticClass: "btn btn-danger",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.removeGroup(group)
          }
        }
      }, [_vm._v("Delete " + _vm._s(_vm.label))]) : _vm._e()])], 1)
    }), 0)])])])
  }), _vm._v(" "), (_vm.component.isRepeatable && !_vm.readonly) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary add-new-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addNewGroup($event)
      }
    }
  }, [_vm._v("Add " + _vm._s(_vm.label))])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b91f70fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/group2.vue
// module id = 1045
// module chunks = 0